<div class="modal-header">
  <div class="forgot-password-layout container-fluid form-content shadow-5">
    <div class="form-content">
      <h2 class="forgot-password-title" style="text-align: center;">Password Reset</h2>
      <form class="g-3 mt-3" [formGroup]="form" (ngSubmit)="onClickSubmit(email)" novalidate>

        <div class="col-6 mb-3">
          <h6>E-mail Address</h6>
          <p class="text-muted text-truncate">{{email}}</p>
        </div>
        <button type="button" class="btn btn-primary btn-block my-4" type="submit">
          <div *ngIf="loading" class="spinner-border spinner-border-sm text-light" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <p *ngIf="!loading">
            Reset Password
          </p>
        </button>
      </form>
    </div>
  </div>
</div>
